import { SvgProps } from 'react-native-svg'

export type IconProps = SvgProps & {
  size?: number
  color?: string
  style?: any
}
